import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import Table from 'src/components/UI/CustomUI/organisms/Table'
import { employeeIsReadOnly, getJob } from 'src/ducks/selectors'
import { PunchlistFile } from 'src/ducks/types'
import headers from './headers'

const All = () => {
  const DEFAULT_PAGE_SIZE = 10
  const [loading] = useState(false)
  const job = useSelector(getJob())
  const [filteredFiles, setFilteredFiles] = useState<PunchlistFile[] | undefined>(job?.fileDetails ? job?.fileDetails.slice(0, DEFAULT_PAGE_SIZE) : [])
  const isReadOnly = useSelector(employeeIsReadOnly)
  const filterFiles = (page: number, pageSize: number) => {
    if (!job?.fileDetails) {
      setFilteredFiles([])
    }
    setFilteredFiles(job?.fileDetails?.filter((file, idx) => {
      if (idx >= page * pageSize && idx <= page * pageSize + pageSize - 1) {
        return true
      }
      return false
    }))

  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    filterFiles(0, 10)
  }, [job])

  return (
    <Table
      headers={headers(isReadOnly)}
      title='ALL'
      loading={loading}
      totalItems={job?.fileDetails ? job?.fileDetails.length : 0}
      callToApi={filterFiles}
      hasTopPagination
      hasPagination={false}
      rowsPerPageDefault={DEFAULT_PAGE_SIZE}
    >
      {filteredFiles}
    </Table>
  )
}

export default All
